@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Configurações</div>
        </div>
      </div>
    </div>
    <div class="pt-3 pr-4 pb-4 pl-4">
      <form [formGroup]="formDados" (ngSubmit)="salvar()">
        <!-- Dados -->
        <div class="subtitulo mt-2 mb-2">Dados</div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <label><b>Razão Social/Telefone:</b></label>
            <input class="form-control form-control-sm" type="text" maxlength="100" name="formulario_razao_social" [ngClass]="{ 'is-invalid': enviado && f.razao_social.errors?.required }" formControlName="razao_social" />
            @if (enviado && f.razao_social.errors?.required) {
              <div class="erro pt-1">Razão Social em branco!</div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="form-row">
          <div class="form-group col-sm-12">
            <label><b>Selecionar Arquivo: (Logomarca)</b></label>
            <input class="form-control form-control-sm" type="file" accept="image/png" (change)="uploadLogomarca($event)" #arquivoLogomarca />
            <div class="mensagem pt-1">* Extensão PNG / * Tamanho Máximo (2MB)</div>
            @if (logomarcaErro) {
              <div class="erro pt-1">Arquivo selecionado acima de 2MB!</div>
            }
            @if (logomarcaInvalida) {
              <div class="erro pt-1">Arquivo inválido!</div>
            }
          </div>
          @if (logomarca == '') {
            <div class="col-sm-12 d-flex align-items-center justify-content-center">
              <h6><b>Nenhuma logomarca selecionada!</b></h6>
            </div>
          }
          @if (logomarca != '') {
            <div class="col-sm-12 text-center">
              <div class="d-flex flex-column justify-content-center">
                <div class="pt-2 pb-2">
                  <img class="logomarca" [src]="logomarca" alt="Logomarca" />
                </div>
                <div class="p-2">
                  <button class="btn btn-danger" type="button" (click)="removerLogomarca()">Remover</button>
                </div>
              </div>
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
        <div class="form-row">
          <div class="form-group col-sm-12">
            <label><b>Selecionar Arquivo: (Arte Rodapé)</b></label>
            <input class="form-control form-control-sm" type="file" accept="image/png" (change)="uploadArteRodape($event)" #arquivoArteRodape />
            <div class="mensagem pt-1">* Extensão PNG / * Tamanho Máximo (2MB)</div>
            @if (arteRodapeErro) {
              <div class="erro pt-1">Arquivo selecionado acima de 2MB!</div>
            }
            @if (arteRodapeInvalida) {
              <div class="erro pt-1">Arquivo inválido!</div>
            }
          </div>
          @if (arteRodape == '') {
            <div class="col-sm-12 d-flex align-items-center justify-content-center">
              <h6><b>Nenhuma arte p/ rodapé selecionada!</b></h6>
            </div>
          }
          @if (arteRodape != '') {
            <div class="col-sm-12 text-center">
              <div class="d-flex flex-column justify-content-center">
                <div class="pt-2 pb-2">
                  <img class="arte_rodape" [src]="arteRodape" alt="arteRodape" />
                </div>
                <div class="p-2">
                  <button class="btn btn-danger" type="button" (click)="removerArteRodape()">Remover</button>
                </div>
              </div>
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Dados (Bancários) -->
        <div class="subtitulo mb-2">Dados (Bancários)</div>
        <div class="form-row">
          <div class="form-group col-sm-3">
            <label><b>Tipo Pagamento:</b></label>
            <input class="form-control form-control-sm" type="text" maxlength="100" name="formulario_tipo_pagamento" formControlName="tipo_pagamento" />
          </div>
          <div class="form-group col-sm-3">
            <label><b>Banco:</b></label>
            <input class="form-control form-control-sm" type="text" maxlength="100" name="formulario_banco" formControlName="banco" />
          </div>
          <div class="form-group col-sm-3">
            <label><b>Agência:</b></label>
            <input class="form-control form-control-sm" type="text" maxlength="20" name="formulario_agencia" formControlName="agencia" />
          </div>
          <div class="form-group col-sm-3">
            <label><b>Conta:</b></label>
            <input class="form-control form-control-sm" type="text" maxlength="50" name="formulario_conta" formControlName="conta" />
          </div>
        </div>
        <!-- Call-Center (Gerar Ligações) -->
        <div class="subtitulo mb-2">Call-Center (Gerar Ligações)</div>
        <div class="form-row">
          <div class="form-group col-sm-4">
            <label><b>Quantidade de ligações por vendedor interno:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" step="1" name="formulario_qtde_ligacoes_vendedor_interno" [ngClass]="{ 'is-invalid': enviado && f.qtde_ligacoes_vendedor_interno.errors?.invalid }" formControlName="qtde_ligacoes_vendedor_interno" />
            @if (enviado && f.qtde_ligacoes_vendedor_interno.errors?.invalid) {
              <div class="erro pt-1">Quantidade de ligações por vendedor interno inválida!</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-4">
            <label><b>Quantidade de dias sem visita p/ gerar ligação:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" step="1" name="formulario_qtde_dias_sem_visita_gerar_ligacao" [ngClass]="{ 'is-invalid': enviado && f.qtde_dias_sem_visita_gerar_ligacao.errors?.invalid }" formControlName="qtde_dias_sem_visita_gerar_ligacao" />
            @if (enviado && f.qtde_dias_sem_visita_gerar_ligacao.errors?.invalid) {
              <div class="erro pt-1">Quantidade de dias sem visita p/ gerar ligação inválida!</div>
            }
          </div>
          <div class="form-group col-sm-4">
            <label><b>Combinação c/ pedidos:</b></label>
            <br />
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="combinacao_pedido" id="optE" value="E" (change)="selecionarCombinacaoPedido($event.target.value)" [checked]="combinacaoPedidoSelecionado == 'E'" />
              <label class="form-check-label" for="optE">e</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="combinacao_pedido" id="optOu" value="O" (change)="selecionarCombinacaoPedido($event.target.value)" [checked]="combinacaoPedidoSelecionado == 'O'" />
              <label class="form-check-label" for="optOu">ou</label>
            </div>
          </div>
          <div class="form-group col-sm-4">
            <label><b>Quantidade de dias sem pedido p/ gerar ligação:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" step="1" name="formulario_qtde_dias_sem_pedido_gerar_ligacao" [ngClass]="{ 'is-invalid': enviado && f.qtde_dias_sem_pedido_gerar_ligacao.errors?.invalid }" formControlName="qtde_dias_sem_pedido_gerar_ligacao" />
            @if (enviado && f.qtde_dias_sem_pedido_gerar_ligacao.errors?.invalid) {
              <div class="erro pt-1">Quantidade de dias sem pedido p/ gerar ligação inválida!</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-4">
            <label><b>Percentual de clientes ativos:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_percentual_clientes_ativos" [ngClass]="{ 'is-invalid': enviado && (f.percentual_clientes_ativos.errors?.invalid || f.percentual_clientes_ativos.errors?.incorrect) }" formControlName="percentual_clientes_ativos" (change)="validarPercentualCliente()" />
            @if (enviado && f.percentual_clientes_ativos.errors?.invalid) {
              <div class="erro pt-1">Percentual de clientes ativos inválido!</div>
            }
            @if (enviado && f.percentual_clientes_ativos.errors?.incorrect) {
              <div class="erro pt-1">Soma dos percentuais de clientes diferente de 100%!</div>
            }
          </div>
          <div class="form-group col-sm-4">
            <label><b>Percentual de clientes inativos:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_percentual_clientes_inativos" [ngClass]="{ 'is-invalid': enviado && (f.percentual_clientes_inativos.errors?.invalid || f.percentual_clientes_inativos.errors?.incorrect) }" formControlName="percentual_clientes_inativos" (change)="validarPercentualCliente()" />
            @if (enviado && f.percentual_clientes_inativos.errors?.invalid) {
              <div class="erro pt-1">Percentual de clientes inativos inválido!</div>
            }
            @if (enviado && f.percentual_clientes_inativos.errors?.incorrect) {
              <div class="erro pt-1">Soma dos percentuais de clientes diferente de 100%!</div>
            }
          </div>
          <div class="form-group col-sm-4">
            <label><b>Percentual de clientes s/ compra:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_percentual_clientes_sem_compra" [ngClass]="{ 'is-invalid': enviado && (f.percentual_clientes_sem_compra.errors?.invalid || f.percentual_clientes_sem_compra.errors?.incorrect) }" formControlName="percentual_clientes_sem_compra" (change)="validarPercentualCliente()" />
            @if (enviado && f.percentual_clientes_sem_compra.errors?.invalid) {
              <div class="erro pt-1">Percentual de clientes s/ compra inválido!</div>
            }
            @if (enviado && f.percentual_clientes_sem_compra.errors?.incorrect) {
              <div class="erro pt-1">Soma dos percentuais de clientes diferente de 100%!</div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Call-Center (Atenção) -->
        <div class="subtitulo mb-2">Call-Center (Atenção)</div>
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Quantidade de dias p/ análise:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" step="1" name="formulario_qtde_dias_analise" [ngClass]="{ 'is-invalid': enviado && f.qtde_dias_analise.errors?.invalid }" formControlName="qtde_dias_analise" />
            @if (enviado && f.qtde_dias_analise.errors?.invalid) {
              <div class="erro pt-1">Quantidade de dias p/ análise inválida!</div>
            }
          </div>
          <div class="form-group col-sm-6">
            <label><b>Quantidade de visitas s/ pedido no período inserido automaticamente:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" step="1" name="formulario_qtde_visitas_sem_pedido_no_periodo" [ngClass]="{ 'is-invalid': enviado && f.qtde_visitas_sem_pedido_no_periodo.errors?.invalid }" formControlName="qtde_visitas_sem_pedido_no_periodo" />
            @if (enviado && f.qtde_visitas_sem_pedido_no_periodo.errors?.invalid) {
              <div class="erro pt-1">Quantidade de visitas s/ pedido no período inserido automaticamente inválida!</div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <!-- Pedidos -->
        <div class="subtitulo mb-2">Pedidos</div>
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Permitir lançar pedido s/ estoque:</b></label>
            <br />
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="pedido_sem_estoque" id="optPedidoSemEstoqueNao" value="N" (change)="selecionarPedidoSemEstoque($event.target.value)" [checked]="pedidoSemEstoqueSelecionado == 'N'" />
              <label class="form-check-label" for="optPedidoSemEstoqueNao">Não</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="pedido_sem_estoque" id="optPedidoSemEstoqueSim" value="S" (change)="selecionarPedidoSemEstoque($event.target.value)" [checked]="pedidoSemEstoqueSelecionado == 'S'" />
              <label class="form-check-label" for="optPedidoSemEstoqueSim">Sim</label>
            </div>
          </div>
          <div class="form-group col-sm-6">
            <label><b>Permitir lançar pedido p/ cliente inadimplente:</b></label>
            <br />
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="pedido_cliente_inadimplente" id="optPedidoClienteInadimplenteNao" value="N" (change)="selecionarPedidoClienteInadimplente($event.target.value)" [checked]="pedidoClienteInadimplenteSelecionado == 'N'" />
              <label class="form-check-label" for="optPedidoClienteInadimplenteNao">Não</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="pedido_cliente_inadimplente" id="optPedidoClienteInadimplenteSim" value="S" (change)="selecionarPedidoClienteInadimplente($event.target.value)" [checked]="pedidoClienteInadimplenteSelecionado == 'S'" />
              <label class="form-check-label" for="optPedidoClienteInadimplenteSim">Sim</label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Percentual permitido de desconto p/ Vendedor(a):</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_percentual_permitido_desconto_vendedor" [ngClass]="{ 'is-invalid': enviado && (f.percentual_permitido_desconto_vendedor.errors?.invalid || f.percentual_permitido_desconto_vendedor.errors?.incorrect) }" formControlName="percentual_permitido_desconto_vendedor" (change)="validarPercentualGestorVendedor()" />
            @if (enviado && f.percentual_permitido_desconto_vendedor.errors?.invalid) {
              <div class="erro pt-1">Percentual permitido de desconto p/ Vendedor inválido!</div>
            }
            @if (enviado && f.percentual_permitido_desconto_vendedor.errors?.incorrect) {
              <div class="erro pt-1">Percentual do Gestor inferior ao percentual do Vendedor!</div>
            }
          </div>
          <div class="form-group col-sm-6">
            <label><b>Percentual permitido de desconto p/ Gestor:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_percentual_permitido_desconto_gestor" [ngClass]="{ 'is-invalid': enviado && (f.percentual_permitido_desconto_gestor.errors?.invalid || f.percentual_permitido_desconto_gestor.errors?.incorrect) }" formControlName="percentual_permitido_desconto_gestor" (change)="validarPercentualGestorVendedor()" />
            @if (enviado && f.percentual_permitido_desconto_gestor.errors?.invalid) {
              <div class="erro pt-1">Percentual permitido de desconto p/ Gestor inválido!</div>
            }
            @if (enviado && f.percentual_permitido_desconto_gestor.errors?.incorrect) {
              <div class="erro pt-1">Percentual do Gestor inferior ao percentual do Vendedor!</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Margem de lucratividade vermelha:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_margem_lucratividade_vermelha" [ngClass]="{ 'is-invalid': enviado && (f.margem_lucratividade_vermelha.errors?.invalid || f.margem_lucratividade_vermelha.errors?.incorrect) }" formControlName="margem_lucratividade_vermelha" (change)="validarMargemLucratividade()" />
            @if (enviado && f.margem_lucratividade_vermelha.errors?.invalid) {
              <div class="erro pt-1">Margem de lucratividade vermelha inválida!</div>
            }
            @if (enviado && f.margem_lucratividade_vermelha.errors?.incorrect) {
              <div class="erro pt-1">Margem verde inferior ou igual a margem vermelha!</div>
            }
          </div>
          <div class="form-group col-sm-6">
            <label><b>Margem de lucratividade verde:</b></label>
            <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="formulario_margem_lucratividade_verde" [ngClass]="{ 'is-invalid': enviado && (f.margem_lucratividade_verde.errors?.invalid || f.margem_lucratividade_verde.errors?.incorrect) }" formControlName="margem_lucratividade_verde" (change)="validarMargemLucratividade()" />
            @if (enviado && f.margem_lucratividade_verde.errors?.invalid) {
              <div class="erro pt-1">Margem de lucratividade verde inválida!</div>
            }
            @if (enviado && f.margem_lucratividade_verde.errors?.incorrect) {
              <div class="erro pt-1">Margem verde inferior ou igual a margem vermelha!</div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        @if (podeForcarAtualizacaoPrecos) {
          <div class="subtitulo mb-2">Vendedores</div>
          <p>Solicitar a atualização de preços e promoções no aplicativo de todos os vendedores da empresa.</p>
          <button class="btn btn-primary mb-3" type="button" [disabled]="forcarAtualizacaoEmAndamento" (click)="forcarAtualizacaoPrecosVendedores()">
            <i class="fa fa-refresh mr-1" [class.fa-spin]="forcarAtualizacaoEmAndamento" aria-hidden="true"></i>
            {{ forcarAtualizacaoEmAndamento ? 'Solicitando atualização...' : 'Forçar Atualização de Preços e Promoções' }}
          </button>
          <hr class="mt-2 mb-2" />
        }
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
